export default __webpack_public_path__ + "static/9-0bc16e0e04f3ccb4cdc1d2d56680458c.webp";